const learnItems = [
  {
    icon: "ri-radar-line",
    color: "#19a2fd",
    title: "How Imperium Identifies Opportunity",
    desc: "Learn how real-time listing and pending activity can trigger immediate outreach — before any other title company gets the call.",
  },
  {
    icon: "ri-mic-ai-line",
    color: "#f1663a",
    title: "How AI Calls Sound in the Real World",
    desc: "Hear title-trained conversations built to open the next closing. These are actual AI-generated calls — this is what agents hear on the other end.",
  },
  {
    icon: "ri-bar-chart-grouped-line",
    color: "#0b1f33",
    title: "How Title Teams Scale Outreach",
    desc: "See how AI helps your team reach more agents than manual outreach ever could — with better timing, consistency, and zero burnout.",
  },
  {
    icon: "ri-money-dollar-circle-line",
    color: "#f1663a",
    title: "How Few Closings It Takes to Justify the Cost",
    desc: "Understand the break-even math and revenue potential. Spoiler: it&apos;s a lot less than you might think.",
  },
];

export default function WebinarLearnSection() {
  return (
    <section id="how-it-works" className="bg-alt-bg py-14 md:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-8 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-white border border-gray-200 rounded-full px-4 py-1.5 mb-5">
            <i className="ri-play-circle-line text-primary text-xs" />
            <span className="text-xs font-semibold text-navy">Webinar Preview</span>
          </div>
          <h2
            className="text-navy font-bold mb-4"
            style={{ fontSize: "clamp(26px, 3vw, 38px)", lineHeight: "1.2" }}
          >
            What You&apos;ll See in the Webinar
          </h2>
          <p className="text-[#4a5568] text-base leading-relaxed">
            A focused 45-minute session covering exactly what it takes for a title company to win more closings through AI-powered outbound.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {learnItems.map((item, i) => (
            <div
              key={item.title}
              className="bg-white rounded-2xl px-5 md:px-7 py-5 md:py-7 border border-gray-100 flex gap-4 md:gap-5 hover:-translate-y-0.5 transition-transform duration-200"
            >
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: item.color + "14" }}
              >
                <i className={`${item.icon} text-xl`} style={{ color: item.color }} />
              </div>
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <span
                    className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 text-white text-[10px] font-bold"
                    style={{ backgroundColor: item.color }}
                  >
                    {i + 1}
                  </span>
                  <h3 className="text-navy font-bold text-base leading-snug">{item.title}</h3>
                </div>
                <p className="text-[#4a5568] text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA note */}
        <div className="mt-6 md:mt-10 text-center">
          <p className="text-[#4a5568] text-sm">
            45 minutes of demo and insight — followed by a live Q&amp;A session.
            &nbsp;
            <a
              href="#webinar-form"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("webinar-form")?.scrollIntoView({ behavior: "smooth", block: "center" });
              }}
              className="text-primary font-semibold hover:underline cursor-pointer whitespace-nowrap"
            >
              Reserve your seat now →
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
